export const lastReserveForm = [
  { name: "نام ورزشکار", key: "fullname", objkey: "client" },
  { name: "تاریخ رزرو", key: "created_at", format: "date" },
  {
    name: "اسم باشگاه/کلاس",
    key: "name",
    objkey: "item_reserve_product",
    type: "state",
    method: (row, i) => {
      if (row) {
        if (row.model_order == "reserve") {
          return row.item_reserve_product && row.item_reserve_product.name;
        } else {
          return row.class_class_product && row.class_class_product.name;
        }
      } else {
        return "ثبت نشده";
      }
    },
  },
  {
    key: "model_order",
    name: "نوع سفارش",
    enum: {
      walletsharge: " شارژ کیف پول",
      reserve: "رزرواسیون",
      joinclass: " ثبت نام در کلاس",
    },
  },
  { key: "total_price", name: "مبلغ کل" },
  { key: "growth_price", name: "مبلغ تراکنش" },
  { name: "موبایل", key: "mobile", objkey: "client" },
  { name: "کد پیگیری", key: "trackingcodeorder" },
  {
    key: "status",
    name: "وضعیت پرداخت",
    enum: {
      waittopay: "پرداخت نشده",
      peyed: "پرداخت شده",
      walletsharge: "شارژ کیف پول",
      payerror: "پرداخت نشده",
    },
  },
  {
    key: "type_payment",
    name: "نوع پرداخت",
    enum: {
      wallet: "کیف پول",
      gateway: "آنلاین",
      manager: "مدیر مجموعه",
    },
  },
  // {
  //   name: "تعداد",
  //   key: "discount",
  // },
];

export const athletesForm = [
  {
    key: "fullname",
    title: "نام ورزشکار",
  },
  {
    key: "mobile",
    title: "شماره موبایل",
  },
  {
    title: "جنسیت ",
    key: "gender",
    type: "enum",
    enum: {
      man: "مرد",
      woman: "زن",
      null: "معلوم نیس",
    },
  },
];
export const detailsReserveForm = [
  { name: "نام شیفت", key: "title" },
  { name: "مبلغ", key: "price" },
  { name: "تعداد", key: "count" },

  { name: "شروع", key: "start" },
  { name: "پایان", key: "end" },
];

export const detailsReserveFormDate = [
  { name: "نام شیفت", key: "title" },
  { name: "مبلغ", key: "price" },
  { name: "تعداد", key: "count" },
  { name: "شروع", key: "start" },
  { name: "پایان", key: "end" },
  { name: "تاریخ شیفت", key: "date", format: "date" },
];

export const sansDetailsReserveForm = [
  { name: "مبلغ", key: "price" },
  { name: "سانس", key: "time" },
  { name: "تاریخ سانس", key: "date", format: "date" },
];
export const classDetailsReserve = [
  { name: "نام کلاس", key: "name" },
  {
    key: "type",
    name: "نحوه برگذاری",
    enum: {
      online: "آنلاین",
      offline: "حضوری",
      both: "آنلاین و حضوری",
    },
  },
];
